// Period configuration for the Past screen (prototype renderPast `cfg`). The
// trend series are the prototype's illustrative figures, not derived values.

export type PastRange = '7d' | '30d' | '90d';

export interface PastCfg {
  xLabels: string[];
  heatCols: string[];
  /** Indices into Worker.fed12 for the heatmap columns. */
  heatIdx: number[];
  subLabel: string;
  regionTrends: Record<string, number[]>;
  /** [in-work %, out-of-work %] per region. */
  inOutData: Record<string, [number, number]>;
  kpi: { fedDelta: number };
  slpTrend: number[];
  hrvTrend: number[];
}

export const PAST_CFG: Record<PastRange, PastCfg> = {
  '7d': {
    xLabels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    heatCols: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    heatIdx: [0, 1, 2, 3, 4, 5, 6],
    subLabel: 'Last 7 days',
    regionTrends: {
      central: [58, 60, 61, 61, 62, 61, 62],
      fleet: [74, 75, 76, 76, 77, 76, 77],
      nl: [62, 63, 64, 64, 65, 64, 66],
      nw: [36, 37, 38, 37, 38, 37, 38],
    },
    inOutData: { central: [30, 70], fleet: [63, 37], nl: [56, 44], nw: [28, 72] },
    kpi: { fedDelta: 3 },
    slpTrend: [5.9, 5.8, 5.7, 5.8, 5.8, 5.7, 5.8],
    hrvTrend: [-14, -15, -16, -15, -17, -16, -18],
  },
  '30d': {
    xLabels: ['W1', 'W2', 'W3', 'W4'],
    heatCols: ['W1', 'W2', 'W3', 'W4'],
    heatIdx: [0, 3, 6, 9],
    subLabel: 'Last 30 days',
    regionTrends: {
      central: [52, 55, 58, 62],
      fleet: [68, 72, 74, 77],
      nl: [55, 58, 62, 66],
      nw: [42, 41, 40, 38],
    },
    inOutData: { central: [32, 68], fleet: [65, 35], nl: [58, 42], nw: [30, 70] },
    kpi: { fedDelta: 6 },
    slpTrend: [6.2, 6.0, 5.9, 5.8],
    hrvTrend: [-8, -11, -14, -18],
  },
  '90d': {
    xLabels: ['M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8', 'M9', 'M10', 'M11', 'M12'],
    heatCols: ['M1', 'M4', 'M7', 'M10'],
    heatIdx: [0, 3, 6, 9],
    subLabel: 'Last 90 days',
    regionTrends: {
      central: [38, 40, 42, 44, 46, 48, 50, 52, 55, 57, 60, 62],
      fleet: [55, 57, 60, 62, 64, 66, 68, 70, 72, 74, 76, 77],
      nl: [42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 63, 66],
      nw: [48, 46, 45, 44, 43, 42, 41, 40, 40, 39, 38, 38],
    },
    inOutData: { central: [35, 65], fleet: [68, 32], nl: [60, 40], nw: [32, 68] },
    kpi: { fedDelta: 14 },
    slpTrend: [6.6, 6.5, 6.4, 6.3, 6.2, 6.1, 6.0, 5.9, 5.9, 5.8, 5.9, 5.8],
    hrvTrend: [-2, -3, -5, -6, -7, -9, -11, -13, -14, -15, -16, -18],
  },
};
